import { requestApi, apiPaths, handleResponse } from '../../config';

export const featureTogglesServices = {
    getFeatureToggles
};

function getFeatureToggles () {
    return requestApi(apiPaths.featureToggles).then(handleResponse);
}
